import { useEffect, useState } from "react";

// Ticket sales stay open through Thursday Oct 1, 2026 at 11:59 PM ET (arrival day)
// = October 2, 2026 03:59:59 UTC (EDT is UTC-4). Programming starts Friday morning.
export const SALES_CLOSE_AT = new Date("2026-10-02T03:59:59Z").getTime();

// Post-deadline: where we redirect people to buy from Jacob directly
export const SKOOL_URL = "https://www.skool.com/superheroswimuniversity/about?ref=2eba9baa063e4d71916d29f262f0acd2";

/**
 * Hook that returns whether ticket sales have closed. Re-checks every 30s
 * so the page auto-flips at midnight without a reload.
 */
export function useSalesClosed() {
  const [closed, setClosed] = useState(() => Date.now() >= SALES_CLOSE_AT);
  useEffect(() => {
    if (closed) return;
    const t = setInterval(() => {
      if (Date.now() >= SALES_CLOSE_AT) setClosed(true);
    }, 30_000);
    return () => clearInterval(t);
  }, [closed]);
  return closed;
}
